import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cs-ag-grid-cell-paragraphs-renderer',
  templateUrl: './cs-ag-grid-cell-paragraphs-renderer.component.html',
  styles: [`
        .wrap-text-cell {
            white-space: normal !important; /* Allows text to wrap */
            word-wrap: break-word !important; /* Breaks long words */
            overflow-wrap: break-word !important;
        }

        .unset-text-clip {
            -webkit-line-clamp: unset !important;
        }

        .para-container {
            display: flex;
            flex-direction: column;
            padding: 12px 0;
            gap: 9px;

            .flex-content {
                display: flex;
                flex-wrap: nowrap;
                column-gap: 4px;
                align-items: center;
            }

            img {
                width: 24px;
                height: 24px;
                border-radius: 50%;
                cursor: pointer;
            }
        }
        .wrap-text-cell {
            white-space: normal !important; /* Allows text to wrap */
            word-wrap: break-word !important; /* Breaks long words */
            overflow-wrap: break-word !important;
        }
        .para-title {
            font-weight: 700 ;
        }
    `]
})
export class CsAgGridCellParagraphsRendererComponent implements OnInit {

  params: any;
  limit: any ;
  readMore: boolean = false;
  moreDetail: boolean = false;
  isExpanded = false;
  showMoreButton: boolean = false;

  constructor() { }

  ngOnInit() {
      if (this.params.showMore) {
          if (this.params.showMore.type === 'readMore') {
             this.readMore = true;
          }
          if (this.params.showMore.type === 'moreDetails') {
              this.moreDetail = true;
          }
          this.showMoreButton = (this.params.showMore.showMoreButton) ? this.params.showMore.showMoreButton : false;
          this.limit = (this.params.showMore.limit) ? this.params.showMore.limit : 5;
      } else {
          this.limit = 'no';
      }
  }

  getStyles(limit, description) {
      if ( limit == 'no' ) {
          this.readMore = false;
          this.isExpanded = true;
      } else {
          if (!this.isExpanded && limit > 0) {
              const length = description ? description.length : 0;
              if (length <= 0) {
                  this.readMore = false;
                  return null;
              } else {
                  this.readMore = true;
                  return {
                      'display': '-webkit-box',
                      '-webkit-line-clamp': limit,
                      '-webkit-box-orient': 'vertical',
                      'overflow': 'hidden',
                      'text-overflow': 'ellipsis'
                  };
              }
          } else {
              this.readMore = false;
              return null;
          }
      }
  }
  onClick() {
      if (this.params.showMore.type == 'moreDetails' ) {
          this.params.showMore.onClick(this.params);
      } else {
          this.readMore = false;
          this.isExpanded = true;
      }
  }

}
